export const generatePaymentSchedule = (loanAmount, termMonths, interestRate, greidslus = 250, startDate = null, loanDate = null) => {
  const rate = interestRate / 100;
  const monthlyRate = rate / 12;
  const dailyRate = rate / 365;
  
  let monthlyPayment;
  if (monthlyRate > 0) {
    monthlyPayment = loanAmount * (monthlyRate * Math.pow(1 + monthlyRate, termMonths)) / (Math.pow(1 + monthlyRate, termMonths) - 1);
  } else {
    monthlyPayment = loanAmount / termMonths;
  }
  
  const today = loanDate || new Date();
  const firstPaymentDate = startDate || new Date(today.getFullYear(), today.getMonth() + 1, 1);
  
  const daysUntilFirstPayment = Math.floor((firstPaymentDate - today) / (1000 * 60 * 60 * 24));
  const oddDaysInterest = loanAmount * dailyRate * Math.max(0, daysUntilFirstPayment);
  
  const schedule = [];
  let remainingBalance = loanAmount;
  let currentDate = new Date(firstPaymentDate);
  
  for (let month = 1; month <= termMonths; month++) {
    let interestPayment = remainingBalance * monthlyRate;
    let totalPayment = monthlyPayment + greidslus;
    
    if (month === 1) {
      interestPayment += oddDaysInterest;
      totalPayment += oddDaysInterest;
    }
    
    const principalPayment = monthlyPayment - (interestPayment - (month === 1 ? oddDaysInterest : 0));
    remainingBalance = Math.max(0, remainingBalance - principalPayment);
    
    schedule.push({
      month: month,
      date: `${String(currentDate.getDate()).padStart(2,'0')}.${String(currentDate.getMonth()+1).padStart(2,'0')}.${currentDate.getFullYear()}`,
      payment: Math.round(totalPayment),
      principal: Math.round(principalPayment),
      interest: Math.round(interestPayment),
      greidslus: greidslus,
      balance: Math.round(remainingBalance)
    });
    
    if (currentDate.getMonth() === 11) {
      currentDate = new Date(currentDate.getFullYear() + 1, 0, 1);
    } else {
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    }
  }
  
  return schedule;
};
